<div class="app-container">
  <idp-header></idp-header>
  <div style="flex: 1">
    <router-outlet></router-outlet>
  </div>
  <idp-footer></idp-footer>
</div>
